var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseComponent } from '../../../common/components/base.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { HubApiService } from '../../../services/hub.api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { HubComponent } from '../hub.component';
var HubNavComponent = /** @class */ (function (_super) {
    __extends(HubNavComponent, _super);
    function HubNavComponent(hubApiService, formBuilder, activatedRoute, parent, router) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.activatedRoute = activatedRoute;
        _this.parent = parent;
        _this.router = router;
        return _this;
    }
    HubNavComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
    };
    HubNavComponent.prototype.goHome = function () {
        this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.eventCalendar, {
            hubName: this.hubName
        }));
    };
    return HubNavComponent;
}(BaseComponent));
export { HubNavComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/nav/hub.nav.component.ts.pre-build-optimizer.js